import React from 'react';
import { Circles } from './components/common/loadingComponent';
import { getLanguage } from './store/storeFunctions';

import criftimelinetrees from './img/CrifTimelineTrees.svg';

import RepiCzWhite from './img/repi/RepiCzWhite.svg';
import RepiSkWhite from './img/repi/RepiSkWhite.svg';
import RepiCzGrey from './img/repi/RepiCzGrey.svg';
import RepiSkGrey from './img/repi/RepiSkGrey.svg';

import './appLoadingScreen.scss';
import './root.scss';
import './components/common/loadingComponent.scss';

export const AppLoadingScreen = () => {
    return (<>
        {localStorage.locales_login === 'blue' && (
            <div className='app-screen app-loading-screen blue-background'>
                <img className="cribis-logo" alt="" src={getLanguage() === 'sk-SK' ? RepiSkWhite : RepiCzWhite}></img>
                <Circles useLoginColor/>
            </div>
        )}
        {localStorage.locales_login === 'tree' && (
            <div>
                <div className="app-loading-screen">
                        <img className="cribis-logo" alt="" src={getLanguage() === 'sk-SK' ? RepiSkGrey : RepiCzGrey}></img>
                    <Circles useLoginColor/>
                </div>
                <div className="cribis-tree">
                    <img alt="" src={criftimelinetrees} style={{ position: "absolute", bottom: "12vh", width: "100vw", opacity: "0.15" }}></img>
                </div>
            </div>
        )}
    </>)
};